"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreditCheckFormCardCms = void 0;
var CreditCheckFormCardCms = /** @class */ (function () {
    function CreditCheckFormCardCms() {
        this.dobLabel = 'Date of birth';
        this.dobInputBoxPlaceHolder = 'mm/dd/yyyy';
        this.dobInputBoxToolTip = "You must be at least 18 years old to place an order for new service.\n                             (Exceptions: Alabama - 19 years old; Puerto Rico - 21 years old)";
        this.ssnLabel = 'Social Security number';
        this.ssnInputBoxToolTip = "Why do we prefer your SSN? To check credit, your Social Security number\n                            is typically faster and more accurate than your driver's license number.";
        this.chkCreditCTALabel = 'Add credit info';
        this.recheckCreditCTALabel = 'Update credit info';
        this.chkAdditionalInfoButtonLabel = 'Continue';
        this.cancelCTALabel = 'Cancel';
        this.dlChkboxLabel = "I'd prefer to use my driver's license number";
        this.dlChkboxLabelSMB = 'I want to use my driver’s license number.';
        this.dlNumberLabel = "Driver's license number";
        this.dlExpDateLabel = 'Expiration Date';
        this.dlStateLabel = 'State';
        this.firstNameLabel = 'First name';
        this.middleNameLabel = 'Middle initial (optional)';
        this.lastNameLabel = 'Last name';
        this.suffixLabel = 'Suffix (optional)';
        this.suffixDropdownValues = ['Sr.', 'Jr.', 'I', 'II', 'III'];
        this.addlInfoPrevAddrChkboxLabel = "Yes, I'd like to provide my previous address";
        this.addlInfoPrevAddrTitleLabel = 'Previous address';
        this.addlInfoPrevAddrSubTextLabel = 'Your previous address could help confirm your identity when verifying credit.';
        this.addlInfoPrevPhoneNumberLabel = 'Previous phone number (optional)';
        this.addlInfoPrevPhoneNumberInputBoxPlaceHolder = '10 digits';
        this.fedTaxIdLabel = 'Federal Tax ID (Employer Identification Number)';
        this.fedTaxIdInputBoxPlaceHolder = 'Federal Tax ID: 12-3456789';
        this.fedTaxIdTooltip = 'If your Federal Tax ID can’t be verified, then you will be asked to provide your date of birth and Social Security Number to perform a personal credit check.';
        this.smbSsnTooltip = "To transfer your phone number securely, we need the primary account holder's Social Security number.";
        this.fedTaxTextLabel = "If your Federal Tax ID can\u2019t be verified, then you\u2019ll be asked to provide your date of birth and Social Security Number to perform a personal credit check. If you need help, please call us at <a href=\"tel:8554551109\">855.455.1109</a>.";
    }
    return CreditCheckFormCardCms;
}());
exports.CreditCheckFormCardCms = CreditCheckFormCardCms;
//# sourceMappingURL=CreditCheckFormCard.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/components/cards/CreditCheckFormCard/CreditCheckFormCard.cms.js
// module id = 2011
// module chunks = 8